import './assets/scss/style.scss'

import { ViteSSG } from "vite-ssg";
import { createPinia } from "pinia";
import App from "./App.vue";
import { routes } from "./router";
import iosScrollbar from '@/directives/iosScrollbar';



import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useFieldsStore } from "@/stores/storeFieldData";


const scrollPositions = {};

export const createApp = ViteSSG(
    App,
    {
        routes,
        scrollBehavior(to, from, savedPosition) {
            const storeScroll = useScrollStore();
            const headerOffset = storeScroll.header?.offsetHeight || 100;
           

            if (to.hash) {
                return {
                    el: to.hash,
                    behavior: "smooth",
                    top: headerOffset,
                };
            }

            if (savedPosition) {
                return savedPosition;
            }
            
            return { top: 0 };
        },
    },
    ({ app, router, initialState }) => {
        const pinia = createPinia();
        app.use(pinia);
        app.directive('ios-scrollbar', iosScrollbar);
        // Восстановление состояния Pinia на клиенте
        if (import.meta.env.SSR) {
            initialState.pinia = pinia.state.value;
        } else {
            pinia.state.value = initialState.pinia || {};
        }

        // Инициализация сторов перед навигацией
        router.beforeEach((to, from, next) => {


            if (typeof window !== 'undefined') {
                scrollPositions[from.fullPath] = {
                    left: window.scrollX,
                    top: window.scrollY,
                };
            }

            // Skip auth check during SSR/SSG
            if (typeof window === 'undefined') {
                next();
                return;
            }

            const storeRequests = useRequestsStore(pinia);
            const storeSettings = useSettingsStore(pinia);
            const storeScroll = useScrollStore(pinia);
            const storeField = useFieldsStore(pinia);


            const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
            const { ref, token } = to.query;
           
            if (Object.keys(to.query).length) {
                const params = new URLSearchParams(to.query).toString();
                localStorage.setItem("registration_params", params);
                // router.replace({ path: to.path, query: {} });
            }
            
            if ( ref ) {
                localStorage.setItem("ref", ref); 
                storeSettings.setReferralCode(ref);               
                // router.replace({ path: to.path, query: {} });
            } else {
                storeSettings.setReferralCode(null);
            }

            if(token) {
                localStorage.setItem("token", token);
                storeRequests.setToken(token);
            }

            if (requiresAuth && !storeRequests.isAuthenticated) {
                next("/");
            } else {
                next();
            }
        });
    }
);
